import { NgModule } from '@angular/core';
import { DeleteConfirmDialogComponent } from './delete-confirm-dialog.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    DeleteConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,

    MatDialogModule,
    MatButtonModule,
  ],
  exports: [
    DeleteConfirmDialogComponent,
  ],
})
export class DeleteConfirmDialogModule {
}
